import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=468917ac&scoped=true"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=468917ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468917ac",
  null
  
)

export default component.exports